import React from "react";
import { Card, Divider } from "antd";
import { CATEGORY_CONFIG } from "variables/constants";

const nominees = [
  {
    name: "Alice Johnson",
    nominator: "John Smith",
    category: "culture-hero",
    nominationDate: "Oct 10, 2025",
    approvedBy: "HR Manager",
    employeeId: "EMP001",
    status: "Pending",
  },
  {
    name: "Bob Martinez",
    nominator: "Sara Lee",
    category: "values-in-action",
    nominationDate: "Oct 12, 2025",
    approvedBy: "Department Head",
    employeeId: "EMP002",
    status: "Approved",
  },
  {
    name: "Catherine Wu",
    nominator: "Michael Brown",
    category: "peak-performer",
    nominationDate: "Oct 14, 2025",
    approvedBy: "HR Manager",
    employeeId: "EMP003",
    status: "Approved",
  },
  {
    name: "Daniel Kim",
    nominator: "Alice Johnson",
    category: "innovation-trailblazer",
    nominationDate: "Oct 15, 2025",
    approvedBy: "Team Lead",
    employeeId: "EMP004",
    status: "Pending",
  },
  {
    name: "Evelyn Park",
    nominator: "David Lee",
    category: "ceo-award",
    nominationDate: "Oct 18, 2025",
    approvedBy: "CEO",
    employeeId: "EMP005",
    status: "Approved",
  },
  {
    name: "Franklin Ng",
    nominator: "Linda Chen",
    category: "ai-adoption-champion",
    nominationDate: "Oct 20, 2025",
    approvedBy: "CTO",
    employeeId: "EMP006",
    status: "Pending",
  },
];

const MyNominationCard = () => {
  return (
    <>
      {nominees.map((item) => {
        const config = CATEGORY_CONFIG[item.category];
        const Icon = config?.icon;
        const colorClass = config?.colorClass;

        return (
          <Card
            key={item.employeeId}
            className={`rounded-2xl overflow-y-auto pr-2 mb-2 nomination ${colorClass}`}
          >
            <div className="flex justify-between items-start relative">

                <span
                  className={`absolute right-5 text-xs text-white p-2 icon-style ${colorClass}`}
                >
                  <Icon className="h-5 w-5" />
                </span>

              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold">
                  {item.name
                    ?.split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>

                <div>
                  <div className="flex gap-2">
                    <h4 className="font-semibold text-base text-gray-800">
                      {item.name}
                    </h4>

                    <span className="status-indicator normal text-[10px]">
                      {item.employeeId}
                    </span>

                    <span
                      className={`status-indicator ${item.status
                        .toLowerCase()
                        .replace(/\s+/g, "-")} text-[10px] px-2`}
                    >
                      {item.status}
                    </span>
                  </div>

                  <p className="text-gray-600 text-[13px]">
                    Nominated by: {item.nominator}
                  </p>
                </div>
              </div>
            </div>

            <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
              <div>
                <p className="text-base text-gray-500 mb-1">Award Category</p>
                <div className="text-base font-medium">{config?.title}</div>
              </div>

              <div>
                <p className="text-base text-gray-500 mb-1">
                  Nomination Date
                </p>
                <div className="text-base font-medium">
                  {item.nominationDate}
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </>
  );
};

export default MyNominationCard;
